'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taxonomy = require('../../taxonomy');

var _taxonomy2 = _interopRequireDefault(_taxonomy);

var _deepFreeze = require('deep-freeze');

var _deepFreeze2 = _interopRequireDefault(_deepFreeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classifications = _taxonomy2.default.classifications;


var allClassificationsViewModel = classifications.map(function (_ref) {
  var description = _ref.description,
      id = _ref.id;
  return {
    description: description,
    searchQuery: { classification: String(id) }
  };
});

var priorityClassificationsRegex = /^(Accounting|Education & Training|Government & Defence|Healthcare & Medical|Sales)$/;
var priorityClassificationsViewModel = allClassificationsViewModel.filter(function (_ref2) {
  var description = _ref2.description;
  return priorityClassificationsRegex.test(description);
});

var viewModel = (0, _deepFreeze2.default)({
  classifications: {
    priority: priorityClassificationsViewModel,
    all: allClassificationsViewModel
  }
});

exports.default = function () {
  return viewModel;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/view-models/quick-search/quick-search.js
 ** module id = 488
 ** module chunks = 0
 **/